import {IToJson} from '@toolify/client/src/types/IToJson'
import {
  IAutomationAppResponseInstance,
} from '@toolify/server/src/adapters/InstanceApiResponseAdapter/types/responseInstances/IAutomationAppResponseInstance'

export function mapAutomationAppResponseInstance(dashboard: IToJson<IAutomationAppResponseInstance>): IAutomationAppResponseInstance {
  return {
    ...dashboard,
  } as IAutomationAppResponseInstance // TODO: TS: Remove "as ..."
}
